import React, {useState} from 'react';
import emailjs from 'emailjs-com';
import './contactForm.css';
import {IoLogoWhatsapp} from "react-icons/io";
import { FaLocationDot } from "react-icons/fa6";
import {email, whatsappUrl} from "../../../components/Constant/socialLinks";
import {FaTelegramPlane} from "react-icons/fa";
import { IoMdMail } from "react-icons/io";

const ContactForm = () => {

    const [feedbackMessage, setFeedbackMessage] = useState('');
    const [messageClass, setMessageClass] = useState('');

    const clearFeedbackMessage = () => {
        setTimeout(() => {
            setFeedbackMessage('');
            setMessageClass('');
        }, 3000);  // 3000 milliseconds = 3 seconds
    };

    const sendEmail = (e) => {
        e.preventDefault();

        // Replace 'YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', and 'YOUR_USER_ID' with your actual values from EmailJS
        emailjs.sendForm('service_1mycaeh', 'template_6jjazv9', e.target, 'ZKWr_IwSWOk9MO-mM')
            .then((result) => {
                console.log(result.text);
                setFeedbackMessage('Message sent successfully!');
                setMessageClass('success');
                clearFeedbackMessage();  // Call to clear the message after banking-license few seconds
            }, (error) => {
                console.log(error.text);
                setFeedbackMessage('Failed to send the message, please try again later.');
                setMessageClass('error');
                clearFeedbackMessage();
            });

        e.target.reset();
    };

    return (
        <div className='wrapper'>
            <div className='contact-container container'>
                <div className="contact-form-container">
                    <h2 className='contact-form-title'>Fill the Blank:</h2>
                    <form className='contact-form' onSubmit={sendEmail}>
                        <input
                            className='contact-form-input'
                            type="text"
                            id="name"
                            name="name"
                            placeholder='Full name'
                            required
                        />
                        <input
                            className='contact-form-input'
                            type="email"
                            id="email"
                            name="email"
                            placeholder='example@company.com'
                            required
                        />
                        <textarea
                            className='contact-form-input'
                            id="message"
                            name="message"
                            rows={5}
                            placeholder='Short brief*'
                            required
                        />
                        <button className='contact-button' type="submit">
                            Submit
                        </button>
                    </form>
                    {feedbackMessage && <p className={`feedback-message ${messageClass}`}>{feedbackMessage}</p>}
                </div>

                <div className="contact-info">
                    <div className='contact-info-item'>
                        <h2 className='contact-info-title'>
                            <IoLogoWhatsapp/>
                            &nbsp;
                            <FaTelegramPlane/>
                        </h2>
                        <div className='contact-info-content'>
                            
                            <a href={whatsappUrl} className='contact-info-link' target="_blank">
                                +4407385054407
                            </a>
                        </div>
                    </div>

                    <div className='contact-info-item'>
                        <h2 className='contact-info-title'>
                            <IoMdMail/>
                        </h2>
                        <div className='contact-info-content'>

                            <a href={email} className='contact-info-link' target="_blank">
                                info@offshoreadvisory.pro
                            </a>
                        </div>
                    </div>
                    
                    <div className='contact-info-item'>
                        <h2 className='contact-info-title'><FaLocationDot/> Address</h2>
                        <div className='contact-info-content'>
                            <p>
                                25B RICHMOND TERRACE, LIVERPOOL, UNITED KINGDOM, L6 5HU
                            </p>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    );
}

export default ContactForm;
